import React, { useState, useEffect } from 'react';

const Footer = () => {
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentYear(new Date().getFullYear());
        }, 1000); // Update every second (though year won't change that often)
        
        return () => clearInterval(interval);
    }, []);

    return (
        <footer className="footer" style={{ backgroundColor: '#343a40', color: '#fff', padding: '20px 0' }}>
            <div className="container text-center">
                <p>&copy; {currentYear} VTAS Associates. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;